import { atom } from 'recoil';
import storage from '../../helpers/storage.js';
import { storageKey as endpointStorageKey } from '../core/eva-endpoint-url-state.js';
import { logger } from '@springtree/eva-sdk-core-logger';
export const storageKey = 'evaUserToken';
// This is one of the core atoms that powers the Context for the root state.
// The other core atom is the EVA endpoint.
// When either change the root state is reset by setting a new RecoilRoot key.
// The endpoint and user token are also used for unique request persistence.
//
const currentUserTokenState = atom({
    key: 'currentUserToken',
    default: storage.getItem(storageKey) || '',
    effects: [
        ({ setSelf, onSet }) => {
            // Set initial value from storage
            //
            setSelf(storage.getItem(storageKey) || '');
            // Update storage on change
            //
            onSet((newValue, oldValue, isReset) => {
                if (newValue !== oldValue) {
                    isReset || !newValue
                        ? storage.removeItem(storageKey)
                        : storage.setItem(storageKey, newValue);
                }
            });
            // Listen for updates applied through local storage
            // Not that storage events are only triggered from other tabs/windows
            // If you update the storage in the active window itself there will be no trigger
            //
            if (globalThis.addEventListener) {
                globalThis.addEventListener('storage', (storageEvent) => {
                    /* istanbul ignore next */
                    switch (storageEvent.key) {
                        case storageKey:
                            {
                                logger.debug('[STATE:currentUserTokenState] Storage event', storageEvent);
                                if (storageEvent.newValue !== storageEvent.oldValue) {
                                    setSelf(storageEvent.newValue ? storageEvent.newValue : '');
                                }
                            }
                            break;
                        case endpointStorageKey:
                            {
                                // Changes to the endpoint warrant this atom being unset
                                //
                                logger.debug('[STATE:currentUserTokenState] Endpoint changed', storageEvent);
                                if (storageEvent.newValue !== storageEvent.oldValue) {
                                    setSelf('');
                                    storage.setItem(storageKey, '');
                                }
                            }
                            break;
                        default:
                            {
                                // NOOP
                            }
                            break;
                    }
                });
            }
        },
    ],
});
export default currentUserTokenState;
//# sourceMappingURL=current-user-token-state.js.map